module.exports = __webpack_public_path__ + "img/zhuanye-card.5e646f38.svg";